<template>
  <div>
    <BaseWeb :logo-img="logoPhoto"
             :app-img-arr="appPhotoArr" :app-name="appName" :company="companyName" :icp-num="icpNum" :one-word="oneWord"
             class="many_recruit_btn"></BaseWeb>
  </div>
</template>

<script>
import BaseWeb from '../components/baseWeb'
export default {
  name: "guoguo",
  components:{
    BaseWeb:BaseWeb
  },
  data(){
    return{
      logoPhoto:require('../assets/guoguoImg/logo.png'),
      appPhotoArr:[
        {id:1,photo:require('../assets/guoguoImg/one.png')},
        {id:2,photo:require('../assets/guoguoImg/tow.png')},
        {id:3,photo:require('../assets/guoguoImg/three.png')},
        {id:4,photo:require('../assets/guoguoImg/four.png')},
      ],
      appName:'果果兼职',
      oneWord:'《果果有钱》是一款专注求职，找工作的APP。\n' +
        '找工作，全职，线下全面覆盖。《果果有钱》职位多，入职快！\n' +
        '满足求职大学生，待业者的工作需求，众多名气直聘的兼职岗位，并提供适配的工作招聘服务的互联网招聘垂直平台。',
      companyName:'上海藤玩网络科技有限公司',
      icpNum:'沪ICP备2020028940号-1',
    }
  }
}
</script>

<style scoped>
.many_recruit_btn{
  --downBtn:rgb(87,196,93);
}
</style>



// WEBPACK FOOTER //
// src/components/guoguo.vue